/* eslint-disable */
/* tslint:disable */

import { EmployeeCreateRequest, EmployeeResponse, EmployeeUpdateRequest, MapString, String } from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

class Employee<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
	/**
	 * No description
	 *
	 * @tags Сотрудники
	 * @summary Добавление нового сотрудника
	 * @request POST:/employee
	 * @secure
	 */
	employeeCreate = (data: EmployeeCreateRequest, params: RequestParams = {}) =>
		this.request<EmployeeResponse, String | void>({
			path: `/employee`,
			method: "POST",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * @description Получение данных сотрудника при переходе на экран редактирования сотрудника
	 *
	 * @tags Сотрудники
	 * @summary Получить карточку сотрудника по его id
	 * @request GET:/employee/{id}
	 * @secure
	 */
	employeeDetail = (id?: string, params: RequestParams = {}) =>
		this.request<EmployeeResponse, void>({
			path: `/employee/${id}`,
			method: "GET",
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Сотрудники
	 * @summary Изменить данные сотрудника
	 * @request PUT:/employee/{id}
	 * @secure
	 */
	employeeUpdate = (data: EmployeeUpdateRequest, id?: string, params: RequestParams = {}) =>
		this.request<EmployeeResponse, void>({
			path: `/employee/${id}`,
			method: "PUT",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Сотрудники
	 * @summary Переместить карточку сотрудника в архив
	 * @request GET:/employee/{id}/archive
	 * @secure
	 */
	archiveDetail = (id?: string, params: RequestParams = {}) =>
		this.request<void, void>({
			path: `/employee/${id}/archive`,
			method: "GET",
			secure: true,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Сотрудники
	 * @summary Восстановить карточку сотрудника из архива
	 * @request DELETE:/employee/{id}/archive
	 * @secure
	 */
	archiveDelete = (id?: string, params: RequestParams = {}) =>
		this.request<void, void>({
			path: `/employee/${id}/archive`,
			method: "DELETE",
			secure: true,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Сотрудники
	 * @summary Значения из справочников для заполнения карточки сотрудника
	 * @request GET:/employee/dictionaries
	 * @secure
	 */
	dictionariesList = (params: RequestParams = {}) =>
		this.request<MapString, void>({
			path: `/employee/dictionaries`,
			method: "GET",
			secure: true,
			format: "json",
			...params,
		});
}
export const employeeAPI = new Employee();
